import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getRecipes = async (
  { page = 1, limit = 25, name, sector, isActive, signal } = {}
) => {
  const query = qs({ page, limit, name, sector, isActive });
  return httpClient.get(`/stock/recipes${query}`, { signal });
};

export const createRecipe = async (data, { signal } = {}) => {
  return httpClient.post("/stock/recipes", data, { signal });
};

export const patchRecipe = async (
  recipeId,
  data,
  { signal } = {}
) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  return httpClient.patch(`/stock/recipes/${recipeId}`, data, {
    signal,
  });
};

export const getRecipe = async (recipeId, { signal } = {}) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  return httpClient.get(`/stock/recipes/${recipeId}`, { signal });
};

export const getRecipeConsumers = async (recipeId, { signal } = {}) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  return httpClient.get(`/stock/recipes/${recipeId}/consumers`, { signal });
};

export const getRecipeVersions = async (
  recipeId,
  { page = 1, limit = 1, signal } = {}
) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");

  const query = qs({ page, limit });
  return httpClient.get(
    `/stock/recipes/${recipeId}/versions${query}`,
    { signal }
  );
};

export const getRecipeVersion = async (
  recipeId,
  versionId,
  { signal } = {}
) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  if (!versionId) throw new Error("El ID de la versión es requerido");

  return httpClient.get(
    `/stock/recipes/${recipeId}/versions/${versionId}`,
    { signal }
  );
};

export const patchRecipeVersion = async (
  recipeId,
  versionId,
  data,
  { signal } = {}
) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  if (!versionId) throw new Error("El ID de la versión es requerido");

  return httpClient.patch(
    `/stock/recipes/${recipeId}/versions/${versionId}`,
    data,
    { signal }
  );
};

export const patchRecipeWithVersion = async (
  recipeId,
  versionId,
  data,
  { signal } = {}
) => {
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  if (!versionId) throw new Error("El ID de la versión es requerido");

  return httpClient.patch(
    `/stock/recipes/${recipeId}/versions/${versionId}/full`,
    data,
    { signal }
  );
};
